export class GqlService {
	static async request(query, variables = {}) {
		const response = await fetch("/api", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${window.publicExpeditionsToken}`,
			},
			body: JSON.stringify({
				query: query,
				variables: variables,
			}),
		});

		return response.json();
	}
}
